import { useEffect, DependencyList } from 'react';

export function useDebounceEffect(
    fn: (...args: any[]) => Promise<void> | void,
    waitTime: number,
    deps?: DependencyList,
  ) {
    useEffect(() => {
      const t = setTimeout(async () => {
        await fn(...(deps || []));
      }, waitTime);
  
      return () => {
        clearTimeout(t);
      };
    }, deps);
  }